"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = SttDateTimePicker;
require("date-fns");
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _styles2 = _interopRequireDefault(require("./styles"));
var _dateFns2 = _interopRequireDefault(require("@date-io/date-fns"));
var _pt = _interopRequireDefault(require("date-fns/locale/pt"));
var _pickers = require("@material-ui/pickers");
var _excluded = ["showSeconds"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return (0, _styles2["default"])(theme);
});
function SttDateTimePicker(_ref) {
  var _ref$showSeconds = _ref.showSeconds,
    showSeconds = _ref$showSeconds === void 0 ? false : _ref$showSeconds,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useStyles();
  var format = showSeconds ? "dd/MM/yyyy HH:mm:ss" : "dd/MM/yyyy HH:mm";
  return /*#__PURE__*/_react["default"].createElement(_pickers.MuiPickersUtilsProvider, {
    utils: _dateFns2["default"],
    locale: _pt["default"]
  }, /*#__PURE__*/_react["default"].createElement(_pickers.KeyboardDateTimePicker, _extends({
    autoOk: true,
    variant: "inline",
    inputVariant: "outlined",
    margin: "dense",
    format: format,
    fullWidth: true,
    InputLabelProps: {
      classes: {
        root: classes.label,
        focused: classes.focused,
        error: classes.error
      }
    },
    InputProps: {
      classes: {
        root: classes.input,
        focused: classes.cssfocused,
        notchedOutline: classes.notchedOutline,
        disabled: classes.disabled,
        error: classes.error
      }
    },
    KeyboardButtonProps: {
      disableRipple: true
    },
    leftArrowButtonProps: {
      disableRipple: true
    },
    rightArrowButtonProps: {
      disableRipple: true
    }
  }, props)));
}